import { Button, Dropdown, Form, Icon, Input, Message, Modal } from "semantic-ui-react";

import "modules/ApiKeys/components/CreateKeyModal/CreateKeyModal.scss";
import { useApiKeyTypeIdDropdownOptions, useCreateKeyModalForm } from "modules/ApiKeys/components/CreateKeyModal/hooks";
import { validateEmail } from "util/common";

export type CreateKeyModalFormProps = {
  isOpen: boolean;
  onClose: () => void;
};

export type CreateApiReadingKey = {
  name: string;
  email: string;
  phone_number: string;
  company_name: string;
  type: number;
};

export const CreateKeyModalForm = ({ isOpen, onClose }: CreateKeyModalFormProps) => {
  const {
    name,
    email,
    phone,
    company,
    formSubmitted,
    isFormSubmitting,
    createAPIKeyTypeId,
    handleAPIKeyTypeDropdownChange,
    onInputChange,
    handleSaveApiKey,
    isMissingValue
  } = useCreateKeyModalForm({ isOpen, onClose });
  const { apiKeyTypeIdDropdownOptions } = useApiKeyTypeIdDropdownOptions();

  return (
    <Modal className="CreateKeyModal" size="small" closeOnDimmerClick open={isOpen} onClose={onClose}>
      <Modal.Header>
        <div className="CreateKeyModal__modal-header">
          <p>Create Token</p>
        </div>
      </Modal.Header>
      <Modal.Content>
        <Form style={{ padding: "0 7px" }}>
          <Form.Group>
            <Form.Field id="name" width={16} required>
              <label>Name</label>
              <Input value={name} fluid name="name" onChange={onInputChange} placeholder="Name" />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field id="company" width={16} required>
              <label>Company </label>
              <Input value={company} fluid name="company" onChange={onInputChange} placeholder="Company" />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field id="phone" width={16} required>
              <label>Phone</label>
              <Input value={phone} fluid name="phone" onChange={onInputChange} placeholder="Phone" />
            </Form.Field>
          </Form.Group>
          <Form.Group>
            <Form.Field id="email" width={16} required>
              <label>Email</label>
              <Input value={email} fluid name="email" onChange={onInputChange} placeholder="Email" />
            </Form.Field>
          </Form.Group>

          <Form.Group style={{ marginBottom: "0" }}>
            <Form.Field id="api_key_type" width={16} required>
              <label>Type</label>
              <Dropdown
                options={apiKeyTypeIdDropdownOptions}
                value={createAPIKeyTypeId}
                fluid
                selection
                name="api_key_type"
                onChange={handleAPIKeyTypeDropdownChange}
                selectOnBlur={false}
              />
            </Form.Field>
          </Form.Group>
        </Form>
        {(formSubmitted && isMissingValue()) || (email && !validateEmail(email)) ? (
          <Message error content={formSubmitted && isMissingValue() ? "All fields are required" : "Invalid email"} />
        ) : null}
      </Modal.Content>
      <Modal.Actions>
        <div className="CreateKeyModal__modal-footer">
          <Button onClick={onClose} basic>
            Cancel
            <Icon className="xmark" />
          </Button>
          <Button color="green" disabled={isFormSubmitting} loading={isFormSubmitting} type="button" onClick={handleSaveApiKey}>
            Save
            <Icon className="check" />
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};
